// Legion Mandate (§33 T5): the Legion Tactics Tower and the Legion Organizer.
//
// While both are the side's (`poweredCount`), its Army Logistics — the Fodder
// Moves each Power Move brings — climbs by `LOGISTICS.legion`, for at most
// `LOGISTICS.legionMax` Mandates. Derived from the board at every refill
// (`fodderMovesFor`), so a fallen Tower stops it at the next turn. "Only two
// at a time" is a placement door (`legionPlaceError`).

import type { Side } from "../board";
import { poweredCount } from "../industry/gear";
import { type IndustryState, LEGION_TOWER } from "../industry/state";
import { LOGISTICS, RULES } from "../rules";

/** `side`'s Army Logistics now: the base, plus its powered Mandates. */
export const armyLogisticsFor = (industry: IndustryState, side: Side): number =>
  RULES.armyLogistics + Math.min(LOGISTICS.legionMax, poweredCount(industry, side, LEGION_TOWER)) * LOGISTICS.legion;

/**
 * Why `owner` may not place a Legion Tactics Tower, or null: two own Towers
 * standing, or two Mandates it powers (a stolen one included), refuse.
 */
export function legionPlaceError(industry: IndustryState, owner: Side): string | null {
  let own = 0;
  for (const structure of industry.structures.values()) {
    if (structure.kind === LEGION_TOWER && structure.owner === owner) own++;
  }
  if (Math.max(own, poweredCount(industry, owner, LEGION_TOWER)) >= LOGISTICS.legionMax) {
    return "you can only have two Legion Mandates";
  }
  return null;
}
